import { DebtType, OutDebt } from '../generated/graphql';
import { getJcapInterests } from './getJcapInterests';

export const getJcapBalance = (debt: OutDebt) => {
  const interests = debt.type === DebtType.Virtual
    ? (debt.extra?.children || [])
      .reduce((total, child) => total + getJcapInterests(child), 0)
    : getJcapInterests(debt);

  return (debt.balance || 0) + interests;
};
